import { render, staticRenderFns } from "./DialogEditIncendioEstado.vue?vue&type=template&id=2cdc7c8e&scoped=true"
import script from "./DialogEditIncendioEstado.vue?vue&type=script&lang=js"
export * from "./DialogEditIncendioEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc7c8e",
  null
  
)

export default component.exports